<template>
    <v-container id="recibos-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    class="alineacentro DatosMatriculado"
                    dark
                    color="success"
                  >
                    <strong>RECIBOS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="2" lg="2">
                  <v-menu
                    v-model="menufiltrofdesde"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocalfdesde"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        height="20px"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.desde"
                      @input="menufiltrofdesde = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-menu
                    v-model="menufiltrofhasta"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocalfhasta"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        height="20px"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.hasta"
                      @input="menufiltrofhasta = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.idpuntoventa"
                    :items="listapuntosventafiltro"
                    label="Punto Venta"
                    item-text="nombre"
                    item-value="idpuntoventa"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-text-field
                    v-model="filtros.recibonro"
                    label="N° Recibo"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    v-model="filtros.concepto"
                    label="Concepto"
                    height="20px"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                  <selector-alumno
                    ref="selalumnofiltro"
                    class="alineaizquierda"
                    @selAlumno="asignaalumnofiltro"
                    :nivel=0
                  ></selector-alumno>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <selector-persona
                    ref="selpersonafiltro"
                    class="alineaizquierda"
                    @selPersona="asignapersonafiltro"
                    :idalumno="filtros.idalumno"
                    titulo="Persona Factura"
                  ></selector-persona>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="Listar('')"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Nuevo Recibo"
                    @click="Nueva"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-new-box </v-icon>
                  </v-btn>
                  <!-- <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Informar Recibo en AFIP"
                    @click="InformaAFIP"
                    :disabled="reciboseleccionado.length === 0 || !permisoescritura || reciboseleccionado[0].idestadocomprobante > 1 || reciboseleccionado[0].pvtipo != 2"
                  >
                    AFIP <v-icon dark> mdi-file-send </v-icon>
                  </v-btn> -->
                  <!-- <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Generar Factura en Talonario Manual"
                    @click="FacturaManual"
                    :disabled="facturaseleccionada.length === 0 || !permisoescritura || facturaseleccionada[0].idestadocomprobante === 4 || (facturaseleccionada[0].idestadocomprobante > 1 && facturaseleccionada[0].pvtipo === 1) || (facturaseleccionada[0].idestadocomprobante === 1 && facturaseleccionada[0].pvtipo > 1)"
                  >
                    Manual <v-icon dark> mdi-receipt-text-check </v-icon>
                  </v-btn> -->
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Anular Recibo"
                    @click="AbreCuadroAnularRecibo"
                    :disabled="reciboseleccionado.length === 0 || !permisoescritura || reciboseleccionado[0].idestadocomprobante === 4"
                  >
                    <v-icon dark> mdi-close </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="success"
                    title="Re-Imprimir Recibo"
                    @click="AbrirCuadroReImprimir"
                    :disabled="reciboseleccionado.length === 0 || !permisolectura || reciboseleccionado[0].idestadocomprobante === 4"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Imprimir o Exportar Listado"
                    @click="AbrirCuadroImprimirExportar"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    v-model="reciboseleccionado"
                    :headers="columnasrecibos"
                    :items="listarecibos"
                    :items-per-page="15"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    single-select
                    show-select
                    item-key="idrecibo"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.estadocomprobante="{ item }">
                      <v-chip :color="getcolor(item.idestadocomprobante)" dark>
                        <p class="textofilagrilla">{{ item.estadocomprobante }}</p>
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">
            {{ mensajetitulo }}
            </v-card-title>
            <v-card-text>
            {{ mensajecuerpo }}
            </v-card-text>
            <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
            <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
            >
            <v-col class="elementocentrado">
                <v-progress-circular indeterminate color="primary" />
            </v-col>
            </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialogverexportar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> Exportar Listado </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="alineaizquierda">
                <v-select
                    v-model="formatosel"
                    :items="listaformatos"
                    label="Formato"
                    item-text="formato"
                    item-value="formato"
                    height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="exportarlistado">
              Exportar
            </v-btn>
            <v-btn color="red darken-1" text @click="dialogverexportar = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevorecibo" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Nuevo Recibo
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarRecibo">
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialognuevorecibo = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12" md="9" lg="9">
                <br />
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>CABECERA</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12" md="4" lg="4">
                        <v-text-field
                            v-model="recibo.concepto"
                            label="Concepto"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                        <v-select
                            v-model="recibo.idpuntoventa"
                            :items="listapuntosventa"
                            label="Punto Venta"
                            item-text="nombre"
                            item-value="idpuntoventa"
                            class="ocupa90"
                            height="20px"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="1"
                        lg="1"
                        class="alineacentro"
                        v-if="recibo.idpuntoventa != '' && listapuntosventa.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].idtipo === 1"
                      >
                        <v-text-field
                          :value="parseInt(listapuntosventa.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].ultnrorecibo) + 1"
                          label="N° Recibo"
                          class="ocupa90"
                          height="20px"
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        :md="recibo.idpuntoventa != '' && listapuntosventa.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].idtipo === 1 ? 2 : 3"
                        :lg="recibo.idpuntoventa != '' && listapuntosventa.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].idtipo === 1 ? 2 : 3"
                        class="alineaizquierda"
                      >
                        <v-menu
                            v-model="menuffac"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="fechalocalrecibo"
                                label="Fecha"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                class="ocupa90"
                                height="20px"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="recibo.fecha"
                            @input="menuffac = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                        <br />
                        Alumno:
                      </v-col>
                      <v-col cols="10" md="8" lg="8" class="alineaizquierda">
                        <selector-alumno
                            ref="selalumnoedit"
                            class="alineaizquierda"
                            :idseleccionado="recibo.idalumno"
                            @selAlumno="asignaalumnoedit"
                            :nivel=0
                        ></selector-alumno>
                      </v-col>
                      <v-col cols="2" md="2" lg="2" class="alineaizquierda">
                        <v-btn
                          class="ma-2"
                          dark
                          x-small
                          color="primary"
                          title="Cargar Alumno"
                          @click="CargaAlumno"
                          :disabled="!permisoescritura || !permisoagregarmatricula"
                        >
                          <v-icon dark> mdi-account-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="listanovedadesalumno.length>0">
                      <v-col cols="12" class="alineaizquierda">
                        Novedades del Alumno
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="listanovedadesalumno.length>0">
                      <v-col cols="12" class="alineaizquierda">
                        <v-data-table
                            :headers="columnasnovedades"
                            :items="listanovedadesalumno"
                            hide-default-footer
                            item-key="idformapago"
                            no-data-text="Sin Registros"
                            multi-sort
                        >
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <br />
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>TOTALES</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="red"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">A COBRAR:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontorecibo().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="success"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">DESCUENTOS:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontodescuentos().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="red"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">RECARGOS:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontorecargos().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="sumamontopagos()<0">
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="success"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">PAGOS:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontopagos().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <br />
                        <v-divider :thickness="6" color="black" opacity="75" />
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            :color="sumatotal() <= 0 ? 'success' : 'red'"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">SALDO:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumatotal().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>DETALLE</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="auto"
                            color="blue"
                            class="alineacentro"
                        >
                          <v-card-text>
                            <v-row row wrap>
                              <v-col cols="12" md="4" lg="4">
                                <v-select
                                  v-model="nuevodetalle.idtipodetalle"
                                  :items="listatiposdetallesrecibo"
                                  label="Concepto"
                                  item-text="nombre"
                                  item-value="idtipodetalle"
                                  height="20px"
                                />
                              </v-col>
                              <v-col cols="12" md="4" lg="4">
                                <v-text-field
                                    v-model="nuevodetalle.descripcion"
                                    label="Descripción"
                                    height="20px"
                                />
                              </v-col>
                              <v-col cols="12" md="2" lg="2">
                                <v-text-field
                                    ref="importecuentadebe"
                                    v-model="nuevodetalle.importe"
                                    label="Importe"
                                    type="number"
                                    prefix="$"
                                    height="20px"
                                />
                              </v-col>
                              <v-col cols="12" md="2" lg="2">
                                <v-btn
                                    class="ma-2"
                                    x-small
                                    color="primary"
                                    title="Agregar Detalle"
                                    @click="AgregaDetalle"
                                    :disabled="recibo.detalles.filter(d=>d.idtipodetalle===1 || d.origen>1).length>0"
                                >
                                  <v-icon dark> mdi-cash-plus</v-icon>
                                </v-btn>
                                <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Detalles Desde CC"
                                    @click="BuscaItemCC"
                                    :disabled="recibo.detalles.filter(d=>d.idtipodetalle===1 || d.origen!=2).length>0"
                                >
                                  <v-icon dark> mdi-account-cash </v-icon>
                                </v-btn>
                                <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Facturas a Imputar"
                                    @click="BuscaFacturas"
                                    :disabled="recibo.detalles.filter(d=>d.idtipodetalle!=1 || d.origen!=3).length>0"
                                >
                                  <v-icon dark> mdi-receipt-text-plus </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row row wrap>
                              <v-col cols="12">
                                <v-data-table
                                    :headers="columnasdetalles"
                                    :items="recibo.detalles"
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text': 'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="id"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Registros"
                                >
                                  <!-- <template v-slot:item.importe="{ item }">
                                    <v-text-field
                                      v-model="item.importe"
                                      label="Importe"
                                      type="number"
                                      class="alineacentro"
                                    />
                                  </template> -->
                                  <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="QuitarDetalle(item)">
                                        mdi-delete
                                    </v-icon>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-card flat height="auto" color="success" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>PAGOS</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12" class="alineaderecha">
                        <v-btn
                            class="ma-2"
                            dark
                            x-small
                            color="primary"
                            title="Agregar Pago"
                            @click="AgregarPago"
                        >
                            <v-icon dark> mdi-cash-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-data-table
                            v-model="itemabonoseleccionado"
                            :headers="columnasabonos"
                            :items="recibo.itemsabonos"
                            hide-default-footer
                            item-key="idformapago"
                            class="elevation-1"
                            dense
                            no-data-text="Sin Registros"
                            multi-sort
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              small
                              @click="QuitarPago(item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogpagos" persistent fullscreen>
        <v-card>
          <v-card-title class="headline"> Nuevo Pago </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                Saldo abonar: {{sumatotal().toFixed(2)}}
              </v-col>
              <v-col cols="12" md="10" lg="10" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GuardarPago">
                    Guardar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialogpagos=false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-spacer />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" lg="3" md="3" class="alineaizquierda">
                <v-select
                    v-model="nuevoabono.idformapago"
                    :items="listaformaspago"
                    label="Forma Pago"
                    item-text="nombre"
                    item-value="idformapago"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" lg="3" md="3" class="alineaizquierda">
                <v-text-field v-model="nuevoabono.importe"
                    label="Importe"
                    type="number"
                    prefix="$"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" lg="6" md="6" class="alineaizquierda">
                <v-text-field v-model="nuevoabono.observacion"
                    label="Observación"
                    height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Agregar Comprobante Pago"
                  @click="AgregarRegistroPago"
                >
                  <v-icon dark> mdi-cash-plus </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                  :headers="columnasregistrosabono"
                  :items="nuevoabono.registros"
                  hide-default-footer
                  item-key="id"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="QuitarRegistroPago(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevoregpago" persistent max-width="800">
        <v-card>
          <v-card-title class="headline">
            Agregar Registro de Comprobante de Pago
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarRegistroPago">
                  Grabar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevoregpago = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <v-row row wrap>
              <v-col cols="12" lg="4" md="4">
                <v-menu
                  v-model="menufrcpago"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalrcpago"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      height="20px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nuevoregpago.fecha"
                    @input="menufrcpago = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="4" md="4">
                <v-menu
                  v-model="menufrcpagoven"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalrcpagoven"
                      label="Vencimiento"
                      prepend-icon="mdi-calendar"
                      height="20px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nuevoregpago.vencimiento"
                    @input="menufrcpagoven = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="4" md="4">
                <v-text-field
                  v-model="nuevoregpago.nrocomprobante"
                  label="N° Comp."
                  height="20px"
                  :rules="[rulesnrocomp.counter]"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" lg="6" md="6">
                <v-text-field
                  v-model="nuevoregpago.referencia"
                  label="Referencia"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" lg="6" md="6">
                <v-text-field
                  v-model="nuevoregpago.monto"
                  label="Monto"
                  type="number"
                  height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevodetalleCC" persistent max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Agregar Items desde CC del Estudiante: {{ facalumno }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="SeleccionarItemsCC">
                  Seleccionar Items
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevodetalleCC = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <v-row row wrap>
              <v-col cols="12" lg="4" md="4" class="alineaizquierda">
                <v-menu
                  v-model="menufcalculo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfcalculo"
                      label="Fecha Cálculo"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechacalculocc"
                    @input="menufcalculo = false"
                    @change="ListaCCAlumno()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="8" md="8" class="alineaizquierda">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar Mov. Pendientes de la CC"
                  @click="ListaCCAlumno()"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" class="alineaderecha info textoNegritaTitulo textoColorBlanco">
                Total Seleccionado: $ {{ sumaitemsselcc() }}
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    v-model="itemsccseleccionado"
                    :headers="columnascc"
                    :items="listacc"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    show-select
                    item-key="idmovimiento"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogFacturas" persistent fullscreen>
        <v-card>
          <v-card-title class="headline">
            Agregar Facturas al Recibo
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="SeleccionarFacturas">
                  Seleccionar Facturas
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogFacturas = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <v-row row wrap>
              <v-col cols="12" class="alineaderecha info textoNegritaTitulo textoColorBlanco">
                Total Seleccionado de Facturas: $ {{ sumafacturasselcc() }}
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    v-model="facturasseleccionadas"
                    :headers="columnasfacturas"
                    :items="listafacturas"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    show-select
                    item-key="idfac"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAlumno" persistent fullscreen>
        <v-card>
          <v-card-title class="headline">
            Agregar Alumno, Inscripción y Matrícula
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GuardaAlumno">
                  Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogAlumno = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <v-row row wrap>
              <v-col cols="12" lg="4" md="4">
                <v-text-field
                  v-model="editedalu.nrodoc"
                  label="N° Documento"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" lg="4" md="4">
                <v-text-field
                  v-model="editedalu.apellido"
                  label="Apellidos"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" lg="4" md="4">
                <v-text-field
                  v-model="editedalu.nombre"
                  label="Nombres"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" lg="6" md="6">
                <v-select
                  v-model="editedalu.idcarrera"
                  :items="listacarrerasmatricula"
                  label="Carrera a Inscribir"
                  item-text="carrera"
                  item-value="idcarrera"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" lg="3" md="3">
                <v-select
                    v-model="editedalu.idsede"
                    :items="listasedesmatricula"
                    label="Sede"
                    item-text="sede"
                    item-value="idsede"
                    height="20px"
                  />
              </v-col>
              <v-col cols="12" lg="3" md="3">
                <v-select
                  v-model="editedalu.anio"
                  :items="listaaniosmatricula"
                  label="Año"
                  item-text="anio"
                  item-value="anio"
                  height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>  
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
import SelectorPersona from '../../components/SelectorPersona.vue';
export default {
  name: "Recibos",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno,
    SelectorPersona: SelectorPersona
  },
  data() {
    return {
      loading: false,
      usuario: "",
      usuariosede: 0,
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 7,
      roles: [],
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      listarecibos: [],
      columnasrecibos: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idrecibo",
          width: 65,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 150,
        },
        {
          text: "Alumno",
          align: "center",
          sortable: true,
          value: "alumno",
          width: 280,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 370,
        },
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "nrocomprobantecompleto",
          width: 130,
        },
        /*  {
          text: "Tit Factura",
          align: "center",
          sortable: true,
          value: "personafactura",
          width: 200,
        }, */
        /* {
          text: "PV",
          align: "center",
          sortable: true,
          value: "pvcodigo",
          width: 65,
        }, */
        /* {
          text: "PVAFIP",
          align: "center",
          sortable: true,
          value: "pvcodafip",
          width: 100,
        }, */
        /* {
          text: "N°",
          align: "center",
          sortable: true,
          value: "numerocomprobante",
          width: 65,
        }, */
        /* {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipocomprobante",
          width: 80,
        }, */
        /* {
          text: "Subtotal",
          align: "center",
          sortable: true,
          value: "subtotal",
          width: 110,
        }, */
        /* {
          text: "IVA",
          align: "center",
          sortable: true,
          value: "iva",
          width: 100,
        }, */
        {
          text: "Total",
          align: "center",
          sortable: true,
          value: "monto",
          width: 110,
        },
        /* {
          text: "CAE",
          align: "center",
          sortable: true,
          value: "cae",
          width: 100,
        }, */
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadocomprobante",
          width: 110,
        }
      ],
      reciboseleccionado: [],
      menufiltrofdesde: false,
      menufiltrofhasta: false,
      filtros: {
        desde: '',
        hasta: '',
        idpuntoventa: -1,
        recibonro: '',
        idalumno: 0,
        idpersonafactura: 0,
        concepto: ''
      },
      dialognuevorecibo: false,
      recibo: {
        idalumno: 0,
        concepto: '',
        idpuntoventa: 0,
        fecha: '',
        detalles: [],
        itemsabonos: [],
        monto: 0.00,
        usuario: ''
      },
      nuevodetalle: {
        id: 0,
        idtipodetalle: 0,
        descripcion: '',
        importe: 0.00
      },
      columnasdetalles: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "id",
          width: 70,
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipodetalle",
          width: 90,
        },
        {
          text: "N° Mov.",
          align: "center",
          sortable: true,
          value: "idmovimientocc",
          width: 70,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 300,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 90,
        }
      ],
      itemabonoseleccionado: [],
      columnasabonos: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
        {
          text: "Forma Pago",
          align: "center",
          sortable: true,
          value: "formapago",
          width: 200,
        },
        {
          text: "Observación",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 300,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 110,
        }
      ],
      listapuntosventa: [],
      listapuntosventafiltro: [],
      menuffac: false,
      dialogpagos: false,
      nuevoabono: {
        idformapago: 1,
        importe: 0.00,
        observacion: '',
        registros: []
      },
      columnasregistrosabono: [
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fecha",
          width: 90,
        },
        {
          text: "N° Comp.",
          align: "center",
          sortable: true,
          value: "nrocomprobante",
          width: 120,
        },
        {
          text: "Ref.",
          align: "center",
          sortable: true,
          value: "referencia",
          width: 120,
        },
        {
          text: "Titular",
          align: "center",
          sortable: true,
          value: "titular",
          width: 180,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 100,
        },
        {
          text: "Vencim.",
          align: "center",
          sortable: true,
          value: "vencimiento",
          width: 110,
        }
      ],
      nuevoregpago: {
        fecha: '',
        nrocomprobante: '',
        referencia: '',
        titular: '',
        monto: 0.00,
        vencimiento: ''
      },
      rulesnrocomp: {
        counter: value => value.length <= 10 || 'Máx. 10 cifras'
      },
      dialognuevoregpago: false,
      menufrcpago: false,
      menufrcpagoven: false,
      listaformaspago: [],
      itemsccseleccionado: [],
      fechacalculo: '',
      listacc: [],
      columnascc: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idmovimiento",
          width: 70,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 300,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 90,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 90,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 90,
        },
        {
          text: "Vencim.",
          align: "center",
          value: "vencimientodmy",
          width: 115,
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "cuotaanio",
          width: 80,
        },
        {
          text: "N° Cuota",
          align: "center",
          sortable: true,
          value: "cuotanro",
          width: 80,
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "cuotacarrera",
          width: 120,
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "cuotatipo",
          width: 100,
        }
      ],
      dialognuevodetalleCC: false,
      facalumno: '',
      menufcalculo: false,
      fechacalculocc: '',
      dialogFacturas: false,
      facturasseleccionadas: [],
      columnasfacturas: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idfac",
          width: 90,
        },
        {
          text: "Tit Factura",
          align: "center",
          sortable: true,
          value: "personafactura",
          width: 250,
        },
        /*{
          text: "PV",
          align: "center",
          sortable: true,
          value: "codpvcompleto",
          width: 80,
        },
         {
          text: "Cod PV",
          align: "center",
          sortable: true,
          value: "codpvcompleto",
          width: 100,
        },
        {
          text: "PV",
          align: "center",
          sortable: true,
          value: "pvnombre",
          width: 150,
        }, */
        {
          text: "N° Factura",
          align: "center",
          sortable: true,
          value: "nrocomprobantecompleto",
          width: 140,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 150,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 90,
        },
        {
          text: "Cuota Venc N°",
          align: "center",
          sortable: true,
          value: "nrovencimiento",
          width: 110,
        },
        {
          text: "Cuota Venc.",
          align: "center",
          sortable: true,
          value: "vencimiento",
          width: 110,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "montovencimiento",
          width: 90,
        },
        {
          text: "CAE",
          align: "center",
          sortable: true,
          value: "cae",
          width: 100,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadocomprobante",
          width: 110,
        }
      ],
      listafacturas: [],
      columnasnovedades: [
        {
          text: "Tipo Novedad",
          align: "center",
          sortable: true,
          value: "tiponovedad",
          width: 150,
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desde",
          width: 90,
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hasta",
          width: 90,
        },
        {
          text: "# Desc.",
          align: "center",
          sortable: true,
          value: "montodescuento",
          width: 90,
        },
        {
          text: "% Desc.",
          align: "center",
          sortable: true,
          value: "porcentajedescuento",
          width: 90,
        },
        {
          text: "# Recgo",
          align: "center",
          sortable: true,
          value: "montorecargo",
          width: 90,
        },
        {
          text: "% Recgo",
          align: "center",
          sortable: true,
          value: "porcentajerecargo",
          width: 90,
        },
        {
          text: "Obs",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 100,
        },
      ],
      listanovedadesalumno: [],
      listatiposdetallesrecibo: [],
      formatosel: 'PDF',
      listaformatos: [{ formato: 'PDF' }, { formato: 'EXCEL' }],
      dialogverexportar: false,
      dialogAlumno: false,
      listaaniosmatricula: [{anio: 2025}],
      listacarrerasmatricula: [],
      editedalu: {
        nrodoc: '',
        apellido: '',
        nombre: '',
        idcarrera: 0,
        idsede: 0,
        anio: 0,
        usuario: ''
      },
      listasedesmatricula: [],
      permisoagregarmatricula: false
    };
  },
    mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    this.usuariosede = localStorage.getItem("idsede");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var roles = localStorage.getItem("rolesusuario");
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion=== 3).length > 0 ? true : false;
        this.permisoagregarmatricula = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion=== 5).length > 0 ? true : false;
        this.filtros.desde= (new Date()).getFullYear().toString() + '-01-01';
        this.filtros.hasta= (new Date()).getFullYear().toString() + '-12-31';
        this.CargaCombosFiltros();
    }
    },
    methods: {
        CargaCombosFiltros () {
          const parametro= JSON.stringify({idsede: parseInt(this.usuariosede), solotipooficial: true, tipos: [3]});
          axios.post("contable/PostPuntosVenta",parametro, {
            headers: {
              "Content-Type": "application/json",
            },
          }).then((result) => {
            if(result.data.resultado===0){
              var talonariosedit = result.data.datos.slice();
              this.listapuntosventa = JSON.parse(JSON.stringify(talonariosedit));
              this.listapuntosventafiltro = result.data.datos;
              this.listapuntosventafiltro.unshift({ idpuntoventa: -1, nombre: "(TODOS)" });

              //cargar formas de pago

              this.loading = false;
            }else{
              this.loading=false;
              this.MostrarMensaje('Error',result.data.resultadomensaje,false);
            }

          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        },
        MostrarMensaje(titulo, cuerpo, home) {
            this.mensajetitulo = titulo;
            this.mensajecuerpo = cuerpo;
            this.mensajehome = home != null ? home : false;
            this.dialogmensaje = true;
        },
        Listar (mensaje) {
            this.loading=true;
            var fecdesde = this.filtros.desde != '' && this.filtros.desde != null ? this.filtros.desde : ' ';
            var fechasta = this.filtros.hasta != '' && this.filtros.hasta != null ? this.filtros.hasta : ' ';
            var recibonro = this.filtros.recibonro != '' && this.filtros.recibonro != null ? this.filtros.recibonro : ' ';
            var idpersonafactura = this.filtros.idpersonafactura != '' && this.filtros.idpersonafactura != null && this.filtros.idpersonafactura != -1 ? this.filtros.idpersonafactura : 0;
            var idalumno = this.filtros.idalumno != '' && this.filtros.idalumno != null && this.filtros.idalumno != -1 ? this.filtros.idalumno : 0;
            var idptoventa = this.filtros.idpuntoventa != '' && this.filtros.idpuntoventa != null && this.filtros.idpuntoventa != -1 ? this.filtros.idpuntoventa : 0;
            var concepto =  this.filtros.concepto != '' && this.filtros.concepto != null ? this.filtros.concepto : ' ';

            axios.get("contable/ListaABMRecibo/" + fecdesde +"/"+ fechasta +"/"+ recibonro +"/"+ concepto +"/"+ idptoventa +"/"+ idpersonafactura +"/"+ idalumno)
            .then((result) => {
                if(result.data.resultado===0){
                this.listarecibos = result.data.datos;
                this.loading=false;
                if (mensaje.length > 0) {
                    this.MostrarMensaje("Error", mensaje, false);
                }
                }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                }
            })
            .catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
            });
        },
        Nueva () {
          this.loading = true;
          this.tituloabm = "Nuevo Comprobante";
          this.recibo= {
            idalumno: 0,
            concepto: '',
            idpuntoventa: this.listapuntosventa.length>0 ? this.listapuntosventa[0].idpuntoventa : 0,
            fecha: this.fechaFormatoYMD(new Date()),
            detalles: [],
            itemsabonos: [],
            monto: 0.00,
            usuario: this.usuario
          };
          this.listanovedadesalumno= [];
          if (this.$refs.selalumnoedit != null) {
            this.$refs.selalumnoedit.QuitarAlumno();
          }
          this.nuevodetalle= {
            id: 0,
            idtipodetalle: 0,
            descripcion: '',
            importe: 0.00
          };
          axios.get("referenciales/tipodetallerecibo")
            .then((result) => {
              if(result.data.resultado===0){
                this.listatiposdetallesrecibotodos = result.data.datos;
                this.listatiposdetallesrecibo = result.data.datos.filter(t=> t.idtipodetalle===2 || t.idtipodetalle===3 || t.idtipodetalle===8 || t.idtipodetalle===9 || t.idtipodetalle===10);
                axios.get("referenciales/formapago")
                  .then((result) => {
                    if(result.data.resultado===0){
                      this.listaformaspago = result.data.datos;
                      this.dialognuevorecibo = true;
                      this.loading = false;
                    }else{
                      this.loading = false;
                      this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                    }
                }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje("Error", error, false);
                });
              }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
        },
        GrabarRecibo () {
            this.loading = true;
            this.recibo.monto= parseFloat(this.sumamontopagos());
            if (this.recibo.monto<0) {
              this.recibo.monto= parseFloat(this.recibo.monto*-1);
            }
            var valida = this.ValidaDatosRecibo();
            if (valida === "OK") {
                const recibo = JSON.stringify(this.recibo);
                axios.post("contable/PostRecibo", recibo, { headers: {"Content-Type": "application/json", }})
                .then((result) => {
                    var d = result.data;
                    if (d.resultado === 0) {
                      this.dialognuevorecibo = false;
                      this.PreguntarExportar(d.nrorecibo.toString(), d.idrecibo, true);
                    } else {
                      var mensaje = "";
                      if (d.resultado === 1 || d.resultado === 99) {
                        //Error al generar factura en BD
                        mensaje = d.resultadomensaje;
                      }
                      this.dialognuevafactura = false;
                      this.Listar(mensaje);
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.MostrarMensaje("Error", error, false);
                });
            } else {
                this.loading = false;
                this.MostrarMensaje("Error", valida, false);
            }
        },
        ValidaDatosRecibo () {
            var valido = "OK";
            if(this.recibo.idalumno === null || this.recibo.idalumno==='' ) {
                valido = "Debe seleccionar el alumno al cual se le debe recibir el pago!!!";
            }
            if (this.recibo.fecha === null || this.recibo.fecha === '') {
                valido = "Debe seleccionar fecha del recibo!!!";
            }
            if (this.recibo.concepto === null || this.recibo.concepto === '') {
                valido = "Debe ingresar el concepto del recibo!!!";
            }
            if (this.recibo.idpuntoventa === null || this.recibo.idpuntoventa === '') {
                valido = "Debe seleccionar el punto de venta!!!";
            }
            if(this.recibo.detalles.length===0) {
                valido = "Debe ingresar los items del recibo!!!";
            }
            if(this.recibo.itemsabonos.length===0) {
                valido = "Debe ingresar los pagos del recibo!!!";
            }
            if(this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length===0 && this.sumatotal()!=0){
                valido = "El total de los abonos debe ser igual al monto a cobrar!!!";
            }
           return valido;
        },
        fechaFormatoYMD(date) {
            return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
        },
        async PreguntarExportar (nro, idrecibo, actualizagrilla) {
            if (await this.$refs.confirm.open("Recibo Generado!!!", "Fue generado el Recibo Nº " + nro + ". Desea ver o exportar la misma?")) {
            // exportar pdf factura
              this.exportarRecibo(idrecibo, actualizagrilla);
            } else {
              this.loading = false;
            }
        },
        exportarRecibo (idrecibo, actualizagrilla) {
            this.loading = true;
            var idrep = 2;  //cae != null && cae.length > 0 ? 22 : 7;
            axios.post("reportes/GetReporte",
            {idreporte: idrep, formato: "PDF",nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idrecibo", valor: idrecibo.toString() }] },{ headers: { "Content-Type": "application/json" }})
            .then((result) => {
                this.loading = false;
                if (result.data.toString().startsWith("Error") === false) {
                window.open(result.data, "_blank");
                if (actualizagrilla === true) {
                    this.Listar('');
                }
                } else {
                this.MostrarMensaje("Error", result.data, false);
                }
            }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
            });
        },
        async AbreCuadroAnularRecibo () {
          if (await this.$refs.confirm.open("Anular Recibo", "Está seguro de anular el recibo " + this.reciboseleccionado[0].idrecibo.toString() + "?")) {
            this.loading = true;
            var recibo = { idrecibo: this.reciboseleccionado[0].idrecibo, usuario: this.usuario };
            axios.put("contable/PutReciboAnular", recibo, { headers: { "Content-Type": "application/json" }})
              .then((result) => {
                var d = result.data;
                if (d.resultado === 0) {
                  this.reciboseleccionado = [];
                  this.Listar('');
                } else {
                  var mensaje = '';
                  if (d.resultado === 1 || d.resultado === 99) {
                    //Error al anular factura en BD
                    mensaje = d.resultadomensaje;
                  }
                  this.Listar(mensaje);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
              });
          }
        },
        AbrirCuadroReImprimir () {
            this.loading = true;
            this.exportarRecibo(this.reciboseleccionado[0].idrecibo, false);
        },
        AbrirCuadroImprimirExportar () {
            this.dialogverexportar = true;
        },
        exportarlistado() {
            this.loading=true;
            var fecdesde = this.filtros.desde != '' && this.filtros.desde != null ? this.filtros.desde : ' ';
            var fechasta = this.filtros.hasta != '' && this.filtros.hasta != null ? this.filtros.hasta : ' ';
            var facturanro = this.filtros.facturanro != '' && this.filtros.facturanro != null ? this.filtros.facturanro : ' ';
            var idpersonafactura = this.filtros.idpersonafactura != '' && this.filtros.idpersonafactura != null && this.filtros.idpersonafactura != -1 ? this.filtros.idpersonafactura : 0;
            var idalumno = this.filtros.idalumno != '' && this.filtros.idalumno != null && this.filtros.idalumno != -1 ? this.filtros.idalumno : 0;
            var idptoventa = this.filtros.idpuntoventa != '' && this.filtros.idpuntoventa != null && this.filtros.idpuntoventa != -1 ? this.filtros.idpuntoventa : 0;
            var concepto =  this.filtros.concepto != '' && this.filtros.concepto != null ? this.filtros.concepto : ' ';
            axios.post("reportes/GetReporte",{ idreporte: 4, formato: this.formatosel,nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [
                    { orden: 1, nombre: "fecdesde", valor: fecdesde },
                    { orden: 2, nombre: "fechasta", valor: fechasta },
                    { orden: 3, nombre: "facturanro", valor: facturanro },
                    { orden: 5, nombre: "idpersonafactura", valor: idpersonafactura },
                    { orden: 6, nombre: "idalumno", valor: idalumno },
                    { orden: 7, nombre: "idptoventa", valor: idptoventa },
                    { orden: 8, nombre: "concepto", valor: concepto }
                ]}, { headers: { "Content-Type": "application/json" }}
            ).then((result) => {
                this.loading = false;
                if (result.data.toString().startsWith("Error") === false) {
                window.open(result.data, "_blank");
                } else {
                this.MostrarMensaje("Error", result.data, false);
                }
            })
            .catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
            });
        },
        asignapersonafiltro (value) {
            this.filtros.idpersonafactura= value!=null ? value.idpersona : 0;
        },
        asignaalumnofiltro (value) {
          this.filtros.idalumno = value!=null ? value.idalumno : 0;
          if(this.$refs.selpersonafiltro!=null){
            this.$refs.selpersonafiltro.idalumno= this.filtros.idalumno;
          }
        },
        asignaalumnoedit (value) {
          this.recibo.idalumno = value!=null ? value.idalumno : 0;
          this.facalumno= value!=null ? value.apellido + ' ' + value.nombre : '';
          if(this.$refs.selalumnoedit!=null){
            this.$refs.selalumnoedit.idalumno= this.recibo.idalumno;
          }
          if(this.recibo.idalumno!=null && this.recibo.idalumno!=0) {
            axios.get('alumno/novedadesalumno/ / /' + this.recibo.idalumno + '/0')
              .then((result) => {
                if(result.data.resultado===0){
                  this.listanovedadesalumno = result.data.datos;
                  this.loading = false;
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadomensaje);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error);
              })
          }
        },
        getcolor(idestadocomprobante) {
            if (idestadocomprobante === 1) {return "grey";}
            else if (idestadocomprobante === 2) {return "green";}
            else if (idestadocomprobante === 3) {return "blue";}
            else if (idestadocomprobante === 4) {return "red";}
        },
        sumamontorecibo () {
          var total = 0.00;
          var i=0;
          for(i=0;i<this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle!=9).length;i++){
            total= parseFloat(total) + parseFloat(this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle!=9)[i].importe)
          }
          return parseFloat(total);
        },
        sumamontodescuentos () {
            var total = 0.00;
            var i=0;
            for(i=0;i<this.recibo.detalles.filter(d=> d.tipomov==='H').length;i++){
                total= parseFloat(total) + parseFloat(this.recibo.detalles.filter(d=> d.tipomov==='H')[i].importe)
            }
            var totaldevolver= parseFloat(total)>0 ? -parseFloat(total) : 0;
            return totaldevolver;
        },
        sumamontorecargos () {
            var total = 0.00;
            var i=0;
            for(i=0;i<this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===9).length;i++){
                total= parseFloat(total) + parseFloat(this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===9)[i].importe)
            }
            return parseFloat(total);
        },
        sumamontopagos () {
          var total = 0.00;
          var i=0;
          for(i=0;i<this.recibo.itemsabonos.length;i++){
            total= parseFloat(total) + parseFloat(this.recibo.itemsabonos[i].importe);
          }
          var totaldevolver= parseFloat(total)>0 ? -parseFloat(total) : 0;
          return totaldevolver;
        },
        sumatotal () {
          var total = 0.00;
          total= this.sumamontorecibo() + this.sumamontorecargos() + this.sumamontodescuentos() + this.sumamontopagos();
          return parseFloat(total);
        },
        AgregaDetalle () {
            if(this.nuevodetalle.idtipodetalle!=null && this.nuevodetalle.idtipodetalle!=''){
                if (this.nuevodetalle.importe > 0) {
                    this.loading = true;
                    var id = 0;
                    id = this.recibo.detalles.length > 0 ? this.recibo.detalles[this.recibo.detalles.length - 1].id+1 : 1;
                    this.recibo.detalles.push({ origen: 1, tipomov: this.listatiposdetallesrecibo.filter(c=> c.idtipodetalle===this.nuevodetalle.idtipodetalle)[0].tipomov, idtipodetalle: this.nuevodetalle.idtipodetalle, idfactura: 0, tipodetalle: this.listatiposdetallesrecibo.filter(c=> c.idtipodetalle===this.nuevodetalle.idtipodetalle)[0].nombre, idmovimientocc: 0,id: id, descripcion: this.nuevodetalle.descripcion, importe: parseFloat(this.nuevodetalle.importe)});
                    this.nuevodetalle.idtipodetalle = 2;
                    this.nuevodetalle.descripcion = '';
                    this.nuevodetalle.importe = 0;
                    this.loading = false;
                    if(this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length>0) {
                      this.Imputaautomatico();
                    }
                } else {
                    this.MostrarMensaje("Error", "Debe ingresar un importe válido!",false);
                }
            }else{
                this.MostrarMensaje("Error", "Debe seleccionar un tipo de concepto del item agregar!",false);
            }
        },
        async QuitarDetalle (item) {
          if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
            this.recibo.detalles.splice(this.recibo.detalles.indexOf(item), 1);
            if(item.tipomov==='D' && item.idtipodetalle===10){
              this.Imputaautomatico();
            }
          }
        },
        AgregarPago () {
            this.nuevoabono= {
                idformapago: 1,
                importe: 0.00,
                observacion: '',
                registros: []
            };
            this.dialogpagos=true;
        },
        GuardarPago () {
          if(this.nuevoabono.importe>0) {
            this.recibo.itemsabonos.push({ idformapago: parseInt(this.nuevoabono.idformapago), formapago: this.listaformaspago.filter(f=> f.idformapago===this.nuevoabono.idformapago)[0].nombre,importe: parseFloat(this.nuevoabono.importe),observacion: this.nuevoabono.observacion, registros: this.nuevoabono.registros });
            if(this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length>0) {
              this.Imputaautomatico();
            }
            this.dialogpagos=false;
          } else {
            this.MostrarMensaje('Error', 'El importe debe ser mayor a 0',false);
          }
        },
        Imputaautomatico() {
          var totaldinero = parseFloat((this.sumamontopagos()*-1) + (this.sumamontodescuentos()*-1));
          var nf = 0;
          for (nf = 0; nf < this.recibo.detalles.filter(d=> d.tipomov==='D').length; nf++) {
            var item= this.recibo.detalles.filter(d=> d.tipomov==='D')[nf];
            if(totaldinero>0) {
              if (totaldinero >= parseFloat(item.importe)) {
                totaldinero = (parseFloat(totaldinero) - parseFloat(item.importe)).toFixed(2);
              } else {
                item.importe = parseFloat(totaldinero);
                totaldinero = 0;
              }
            }
          }
        },
        async QuitarPago (item) {
          if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
            this.recibo.itemsabonos.splice(this.recibo.itemsabonos.indexOf(item), 1);
            if(this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length>0) {
              this.Imputaautomatico();
            }
          }
        },
        AgregarRegistroPago () {
            this.nuevoregpago= {
                fecha: '',
                nrocomprobante: '',
                referencia: '',
                titular: '',
                monto: 0.00,
                vencimiento: ''
            };
            this.dialognuevoregpago=true;
        },
        GrabarRegistroPago () {
            //this.nuevoabono.registros.push({ id: this.nuevoregpago.id, idregistro: this.nuevoregpago.idregistro, fecha: this.nuevoregpago.fecha, nrocomprobante: this.nuevoregpago.nrocomprobante, referencia: this.nuevoregpago.referencia, monto: this.nuevoregpago.monto, vencimiento: this.nuevoregpago.vencimiento })
            this.nuevoabono.registros.push({ fecha: this.nuevoregpago.fecha, nrocomprobante: this.nuevoregpago.nrocomprobante, referencia: this.nuevoregpago.referencia, titular: this.nuevoregpago.titular, monto: parseFloat(this.nuevoregpago.monto), vencimiento: this.nuevoregpago.vencimiento })
            this.dialognuevoregpago=false;
        },
        async QuitarRegistroPago (item) {
            if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
                this.nuevoabono.registros.splice(this.nuevoabono.registros.indexOf(item), 1);
            }
        },
        BuscaItemCC () {
            this.loading = true;
            this.fechacalculocc = this.fechaFormatoYMD(new Date());
            this.itemsccseleccionado = [];
            if (this.recibo.idalumno != null && this.recibo.idalumno != "") {
                this.ListaCCAlumno();
            } else {
                this.loading = false;
                this.MostrarMensaje("Error", "Falta Seleccionar el Alumno!!!", false);
            }
        },
        ListaCCAlumno () {
            const param= JSON.stringify({ idalumno: this.recibo.idalumno, fechacalculo: this.fechacalculocc });
            axios.post("alumno/PostCCAlumno", param, {
                headers: {
                    "Content-Type": "application/json",
                },
                }).then((result) => {
                  if(result.data.resultado===0){
                    this.listacc = result.data.datos;
                    this.dialognuevodetalleCC = true;
                    this.loading = false;
                  }else{
                    this.loading = false;
                    this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                  }
                }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje("Error", error, false);
                });
        },
        SeleccionarItemsCC () {
          if(this.itemsccseleccionado.length>0){
            var i=0;
            var id = 0;
            var idtipodetalle=0;
            var tipodetalle='';
            this.recibo.detalles= [];
            for(i=0; i<this.itemsccseleccionado.length;i++){
                id = this.recibo.detalles.length > 0 ? this.recibo.detalles[this.recibo.detalles.length - 1].id+1 : 1;
                idtipodetalle = this.itemsccseleccionado[i].idcuota!=null ? this.itemsccseleccionado[i].cuotaidtipo===1 ? 2 : 4 : 10;
                tipodetalle= this.listatiposdetallesrecibo.filter(c=> c.idtipodetalle===idtipodetalle)[0].nombre;
                this.recibo.detalles.push({ origen: 2, tipomov: this.listatiposdetallesrecibo.filter(c=> c.idtipodetalle===idtipodetalle)[0].tipomov, idtipodetalle: idtipodetalle, idfactura: 0, tipodetalle: tipodetalle, idmovimientocc: this.itemsccseleccionado[i].idmovimiento,id: id, descripcion: this.itemsccseleccionado[i].descripcion, importe: parseFloat(this.itemsccseleccionado[i].saldo)});
                //this.recibo.detalles.push({ idtipodetalle: 1, idconcepto: idconcepto, concepto: concepto, idmovimientocc: this.itemsccseleccionado[i].idmovimiento,id: id, descripcion: this.itemsccseleccionado[i].descripcion, importe: parseFloat(this.itemsccseleccionado[i].saldo)});
            }
            this.dialognuevodetalleCC=false;
            if(this.recibo.itemsabonos.length>0 && this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length>0){
              this.Imputaautomatico();
            }
          }else{
            this.MostrarMensaje('Error','Debe seleccionar items de la Cuenta Corriente!',false);
          }
        },
        sumaitemsselcc () {
            var total = 0.00;
            var i=0;
            for(i=0; i<this.itemsccseleccionado.length;i++){
                total= parseFloat(total) + parseFloat(this.itemsccseleccionado[i].saldo);
            }
            return parseFloat(total);
        },
        BuscaFacturas () {
            this.loading = true;
            this.facturasseleccionadas = [];
            if (this.recibo.idalumno != null && this.recibo.idalumno != "") {
                this.ListaFacturas();
            } else {
                this.loading = false;
                this.MostrarMensaje("Error", "Falta Seleccionar el Alumno!!!", false);
            }
        },
        ListaFacturas () {
            const param= JSON.stringify({ idalumno: this.recibo.idalumno });
            axios.post("contable/Postfacturasapagar", param, {
                headers: {
                    "Content-Type": "application/json",
                },
                }).then((result) => {
                  if(result.data.resultado===0){
                    this.listafacturas = result.data.datos;
                    this.dialogFacturas = true;
                    this.loading = false;
                  }else{
                    this.loading = false;
                    this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                  }
                }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje("Error", error, false);
                });
        },
        SeleccionarFacturas () {
          if(this.facturasseleccionadas.length>0){
            var i=0;
            var validation='';
            for(i=0; i<this.facturasseleccionadas.length;i++){
                var idf= this.facturasseleccionadas[i].idfactura;
                if(this.facturasseleccionadas.filter(f=> f.idfactura===idf).length>1){
                    validation= 'Se seleccionó dos cuotas de la misma factura. Revise!';
                }
            }
            if (validation.length===0){
                i=0;
                var id = 0;
                var tipodetalle='';
                this.recibo.detalles= [];
                for(i=0; i<this.facturasseleccionadas.length;i++){
                    id = this.recibo.detalles.length > 0 ? this.recibo.detalles[this.recibo.detalles.length - 1].id+1 : 1;
                    tipodetalle= this.listatiposdetallesrecibotodos.filter(c=> c.idtipodetalle===1)[0];
                    this.recibo.detalles.push({ origen: 3, tipomov: tipodetalle.tipomov, idtipodetalle: 1, idfactura: this.facturasseleccionadas[i].idfactura, tipodetalle: tipodetalle.nombre, idmovimientocc: 0,id: id, descripcion: this.facturasseleccionadas[i].nrocomprobantecompleto + ' - ' + this.facturasseleccionadas[i].concepto, importe: parseFloat(this.facturasseleccionadas[i].montovencimiento)});
                    //this.recibo.detalles.push({ idtipodetalle: 1, idconcepto: idconcepto, concepto: concepto, idmovimientocc: this.itemsccseleccionado[i].idmovimiento,id: id, descripcion: this.itemsccseleccionado[i].descripcion, importe: parseFloat(this.itemsccseleccionado[i].saldo)});
                }
                this.dialogFacturas=false;
            }else{
                this.MostrarMensaje('Error',validation,false);
            }
          }else{
            this.MostrarMensaje('Error','Debe seleccionar Facturas!',false);
          }
        },
        sumafacturasselcc() {
            var total = 0.00;
            var i=0;
            for(i=0; i<this.facturasseleccionadas.length;i++){
                total= parseFloat(total) + parseFloat(this.facturasseleccionadas[i].montovencimiento);
            }
            return parseFloat(total);
        },
        CargaAlumno () {
          var param= { anio: 0 }
          axios.post("inscripcioncarrera/PostCarrerasActivas",param, { headers: { "Content-Type": "application/json",}}).then((result) => {
            if(result.data.resultado===0){
              this.listacarrerasmatricula = result.data.datos; //.filter(c=> c.idnivel===4 || c.idnivel===1);
              this.listaaniosmatricula=[];
              var i=0;
              var anioactual= (new Date()).getFullYear()
              var inicio= anioactual;
              for(i=inicio;i<=anioactual+1;i++){
                this.listaaniosmatricula.push({anio: i});
              }
              i=0;
              this.listasedesmatricula=[];
              for(i=0;i<=this.listacarrerasmatricula.length-1;i++){
                if(this.listasedesmatricula.filter(s=> s.idsede===this.listacarrerasmatricula[i].idsede).length===0){
                  this.listasedesmatricula.push({idsede: this.listacarrerasmatricula[i].idsede, sede: this.listacarrerasmatricula[i].sede});
                }
              }
              this.editedalu= {
                nrodoc: '',
                apellido: '',
                nombre: '',
                idcarrera: 1,
                idsede: 1,
                anio: anioactual+1,
                usuario: this.usuario
              };
              this.dialogAlumno=true;
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });

          
        },
        GuardaAlumno () {
          const alumno = JSON.stringify(this.editedalu);
          axios.post("inscripcioncarrera/PostMatriculacionxRecibo", alumno, { headers: {"Content-Type": "application/json", }}).then((result) => {
            /*agregar mov a la grilla detalles*/
            if(result.data.resultado===0){
              var id = 0;
              this.recibo.detalles= [];
              id = this.recibo.detalles.length > 0 ? this.recibo.detalles[this.recibo.detalles.length - 1].id+1 : 1;
              var datos= result.data.datos[0];
              this.recibo.detalles.push({ origen: 2, tipomov: 'D', idtipodetalle: 2, idfactura: 0, tipodetalle: 'Matricula Anual', idmovimientocc: datos.idmovimiento,id: id, descripcion: datos.descripcion, importe: parseFloat(datos.saldo)});
              
              if(this.$refs.selalumnoedit!=null){
                this.recibo.idalumno= datos.idalumno;
                this.$refs.selalumnoedit.idseleccionado= datos.idalumno;
                this.$refs.selalumnoedit.BuscarAlumno();
              }
              this.recibo.concepto= 'Matricula Anual';
              this.dialogAlumno = false;
              if(this.recibo.itemsabonos.length>0 && this.recibo.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length>0){
                this.Imputaautomatico();
              }
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
          });
        }
    },
    computed: {
      fechalocalfdesde: function () {
        if (this.filtros.desde != null && this.filtros.desde != "") {
        var fecha = new Date(this.filtros.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
        } else {
        return "";
        }
      },
      fechalocalfhasta: function () {
        if (this.filtros.hasta != null && this.filtros.hasta != "") {
        var fecha = new Date(this.filtros.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
        } else {
        return "";
        }
      },
      fechalocalrecibo: function () {
        if (this.recibo.fecha != null && this.recibo.fecha != "") {
        var fecha = new Date(this.recibo.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
        } else {
        return "";
        }
      },
      fechalocalrcpago: function () {
        if (this.nuevoregpago.fecha != null && this.nuevoregpago.fecha != "") {
        var fecha = new Date(this.nuevoregpago.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
        } else {
        return "";
        }
      },
      fechalocalrcpagoven: function () {
        if (this.nuevoregpago.vencimiento != null && this.nuevoregpago.vencimiento != "") {
        var fecha = new Date(this.nuevoregpago.vencimiento);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
        } else {
        return "";
        }
      },
      fechalocalfcalculo: function () {
        if (this.fechacalculocc != null && this.fechacalculocc != "") {
            var fecha = new Date(this.fechacalculocc);
            fecha.setDate(fecha.getDate() + 1);
            return fecha.toLocaleDateString("es-AR");
        } else {
            return "";
        }
      }
    }
  };
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.filadeuda td {
  color: red;
}
.textoColorBlanco {
  color: white;
}

.filadescuento td {
  color: green;
}

.filatotal td {
  color: blue;
}

.titulocardchico {
padding: 8px !important;
}
.textocentrado {
text-align: center;
}
.elementocentrado {
display: flex;
justify-content: center;
align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
padding: 2px !important;
}
@media only screen and (min-width: 960px) {
.altojusto {
  height: 45px !important;
}
}
.alineaizquierda {
text-align: left;
}
.alineacentro {
text-align: center;
}
.alineaderecha {
text-align: right;
}
.ocupa30 {
width: 30%;
}
.ocupa45 {
width: 45%;
}
.ocupa50 {
width: 50%;
}
.ocupa60 {
width: 60%;
}
.ocupa75 {
width: 75%;
}
.ocupa80 {
width: 80%;
}
.ocupa95 {
width: 95%;
}
.centradovertical {
vertical-align: middle;
align-items: center;
}
.abajovertical {
vertical-align: bottom;
}
.TituloGrilla {
font-family: Tahoma;
font-size: medium;
font-weight: bold;
background-color: darkgray;
}
.TituloGrilla2 {
font-family: Tahoma;
font-size: medium;
font-weight: bold;
color: white;
background-color: dimgray;
}
.textoNegritaRojo {
color: red !important;
font-weight: bold !important;
}
.textoNegrita {
font-weight: bold !important;
}
.textoNegritaTitulo {
font-weight: bold !important;
font-size: medium;
}
.textoNegritaMontos {
font-weight: bold !important;
font-size: 11pt;
padding-right: 10px;
}
.margenizquierdo{
  padding-left: 10px;
}
.textoNegritaVerde {
color: rgb(83, 248, 125) !important;
font-weight: bold !important;
}
.container {
max-width: unset !important;
}
</style>